module.exports = __webpack_public_path__ + "static/media/play-button-blue-bg.0adc51b8.png";